module.exports = __webpack_public_path__ + "img/7-4.f3722fe9.png";